import { defineComponent as _defineComponent } from 'vue'
import WalletListing from 'ah-wallets/src/components/WalletListing.vue';
import WalletInfo from 'ah-wallets/src/components/WalletInfo.vue';
import CreateTradeModal from 'ah-trades/src/components/modals/CreateTradeModal.vue';
import AddMoneyModal from 'ah-wallets/src/components/AddMoneyModal.vue';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import { AuthorityType, Wallet, Client } from 'ah-api-gateways';
import OnBehalfOf from 'ah-common-lib/src/onBehalfOf/OnBehalfOf';
import { TableConfiguration, TableFieldDefinition } from 'ah-common-lib/src/models';
import { DEFAULT_INACTIVITY_TIMEOUT } from 'ah-common-lib/src/constants/time';
import { useAuthStore } from '@/app/store/authStore';
import { useNotificationsStore } from 'ah-notifications/src/store';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { getServices } from '@/app/services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletsView',
  props: {
  clientId: { type: String, required: false },
  walletId: { type: String, required: false },
},
  setup(__props) {

const props = __props;

const walletListTableFields: TableFieldDefinition[] = [
  {
    header: 'Currency',
    key: 'currency',
  },
  {
    header: '',
    key: 'inTransit',
    colStyle: { width: '4em' },
  },
  {
    header: 'Balance',
    key: 'balance',
    colStyle: { width: '20%' },
  },
  {
    header: 'Fee Warning',
    key: 'feeWarning',
    colStyle: { width: '2em' },
    class: 'fee-warning',
  },
];

const walletListNarrowTableFields: TableFieldDefinition[] = [
  {
    header: 'Currency',
    key: 'currency',
  },
  {
    header: '',
    key: 'inTransit',
    colStyle: { width: '4em' },
  },
  {
    header: 'Fee Warning',
    key: 'feeWarning',
    colStyle: { width: '2em' },
  },
];

const sortAndPageParams = { sort: 'currency', sortDirection: 'ASC' };

const router = useRouter();

const route = useRoute();

const services = getServices();

const requestManager = useRequestManager().manager;

const authStore = useAuthStore();



const onBehalfOfClient = ref<Client | null>(null);

const animatedState = ref<AnimatedListingWithSubViewState | null>(null);

const selectedWallet = ref<Wallet | null>(null);

const walletListing = ref<InstanceType<typeof WalletListing>>();

const walletInfo = ref<InstanceType<typeof WalletInfo>>();

const refreshComponentTimeout = ref<number | null>(null);

onMounted(() => refreshComponent());

function refreshComponent() {
  refreshComponentTimeout.value = window.setInterval(() => {
    walletListing.value!.loadData();
  }, DEFAULT_INACTIVITY_TIMEOUT);
}

function onClientIdChange() {
  if (props.clientId) {
    requestManager
      .sameOrCancelAndNew(`getClient-${props.clientId}`, services.client.getClient(props.clientId))
      .subscribe((response) => (onBehalfOfClient.value = response));
  }
}

watch(() => props.clientId, onClientIdChange, { immediate: true });

function onTradeCompleted() {
  if (walletInfo.value) {
    walletInfo.value.refresh();
  }
}

const narrowWalletListing = computed(() => !animatedState.value!.wideList);
const tableConfig = computed<TableConfiguration>(() => ({
  tableFields: narrowWalletListing.value ? walletListNarrowTableFields : walletListTableFields,
}));
const isAgent = computed(() => authStore.isAgent);
const openTradeAllowed = computed(() => authStore.hasAuthorities(AuthorityType.OPEN_TRADE));
const requestPricesAllowed = computed(() => authStore.hasAuthorities(AuthorityType.REQUEST_PRICES));
const selectedCurrency = computed(() => (selectedWallet.value ? selectedWallet.value.currency : undefined));
const readonly = computed(() => route.meta?.readonly || false);

function onWalletChanged() {
  if (walletListing.value) {
    walletListing.value.loadData();
  }
}

function goToWallet(wallet?: Wallet) {
  const baseUrl = isAgent.value
    ? props.clientId
      ? `/admin/activity/clients/${props.clientId}/`
      : '/admin/'
    : '/dashboard/';

  if (!wallet || props.walletId === wallet.id) {
    router.push({ path: `${baseUrl}wallets` });
    selectedWallet.value = null;
  } else {
    router.push({ path: `${baseUrl}wallets/${wallet.id}` });
    selectedWallet.value = wallet;
  }
}

function downloadBalanceCertificate() {
  requestManager
    .cancelAndNew('downloadBalanceCerticate', services.wallet.downloadBalanceCertificate(props.clientId))
    .subscribe((doc) => useNotificationsStore().triggerFileExportRequestNotification(doc));
}

function openModal(show: Function) {
  authStore.checkComplianceApproval({ showModal: true, client: onBehalfOfClient.value! }).then(() => {
    show();
  });
}

onUnmounted(() => {
  if (refreshComponentTimeout.value !== null) clearInterval(refreshComponentTimeout.value);
});

return { __sfc: true,walletListTableFields, walletListNarrowTableFields, sortAndPageParams, router, route, services, requestManager, authStore, props, onBehalfOfClient, animatedState, selectedWallet, walletListing, walletInfo, refreshComponentTimeout, refreshComponent, onClientIdChange, onTradeCompleted, narrowWalletListing, tableConfig, isAgent, openTradeAllowed, requestPricesAllowed, selectedCurrency, readonly, onWalletChanged, goToWallet, downloadBalanceCertificate, openModal, WalletListing, WalletInfo, CreateTradeModal, AddMoneyModal, InfoTooltip, OnBehalfOf }
}

})